import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { WebParameterContext } from '../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../service/messageclient.service';
declare var app;
@Component({
  selector: 'app-store-list',
  templateUrl: './store-list.page.html',
  styleUrls: ['./store-list.page.scss'],
})
export class StoreListPage implements OnInit {

  @Input() ConfigName: string;
  @Input() PageName: string;
  @Input() PageTitle: string;
  @Input() Param: any;
  loading: boolean = false;//加载效果
  apiObj = {
    status: false,
    msg: ''
  };//接口状态

  AssistingPeople: any = [];
  arrayList: Array<any> = [];
  searchValue:any = "";//查询值
  searchPlaceholder:any = "";//查询提示
  _type:any="";//判断类型
  constructor(
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
  ) {
  
  }

  ngOnInit() {
   const that=this;
    that._type= that["type"];
    this.searchPlaceholder = "门店名称";
    this.BindInfo();
  }

  /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      // this.LoadDataInfo(1);
      this.BindInfo();
    }
  }
  checkItem(item,i){
    let that = this;
    // debugger;
    item["isCheck"] = !item["isCheck"];
    that.arrayList.forEach((it)=>{
      if(it["a_ID"]!=item["a_ID"])
      {
        if(item["isCheck"]){
          it["isCheck"] = !item["isCheck"];
        }else{
          it["isCheck"] = false;
        }
        
      }
    })
    
  }

  dismissModal() {
    const that=this;
    let _array:Array<any> = new Array<any>();
    _array= that.arrayList.filter(item=>item.isCheck);
    this.modalController.dismiss({
      "modalStatus": false,
      "type":that._type,
      "info": _array
    });
  }
  comfireModal() {
    const that=this;
    //debugger;
    let _array:Array<any> = new Array<any>();
    _array= that.arrayList.filter(item=>item.isCheck);
    if(_array.length<=0){
      that.msg.Alert("请选择一家门店");
      return;
    }
    this.modalController.dismiss({
      "modalStatus":true,
      "type":that._type,
      "info": _array
    });
  }

  /**
   * 获取所以邀请人
   */
  BindInfo() {
    const that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    let _obj = {};
    const PageName = this.PageName;
    // const id = this.Param.id;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBStoreXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if(that.searchValue){
      _obj["a_Name"]=that.com.LikeSearch(that.searchValue);
    }
    body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.loading = true;
        that.arrayList = data.Status.Datas;
      } else {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
        // that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = "网络繁忙，请稍后再试！";
      that.loading = true;
      console.log(error);
    });
  }


}
